// Angular
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
// Libraries
// Rxjs
// Afidium
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';
import { SashaBreadcrumbService } from "app_sasha/shared/components/breadcrumb/sasha-breadcrumb.service";
import { IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";
import {
    EImportMode,
    IFieldConfig,
    IImportQueryParam,
    INotificationImport,
    ISimpleBookingImport
} from "app_sasha/pages/import-booking/config/import-booking.interface";
import { ImportBookingFieldsetService } from "app_sasha/pages/import-booking/import-booking-fieldset.service";
import { NotificationType } from "libraries/interfaces/INotification";
import { markAllTouched } from "libraries/service/form/mark-touched.util";
import { ETextAreaClass } from "libraries/module/formbuilder/fields/simple-textarea-field/simple-textarea-field.component";
import { finalize } from "rxjs/operators";
import { BookingResourceService } from "libraries/service/resources/booking/bookingResource.service";
import { ActivatedRoute, Router } from "@angular/router";
import { EnumsResourceService } from "libraries/service/booking/enums/enums-resource.service";
import { HelperService } from "app_sasha/shared/services/helper.service";
import { CardFormComponent, IOptionsCardForm } from "libraries/module/formbuilder/forms/card-form/card-form.component";
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";
import {
    IBookingHostCode,
    IImportBookingErrorReponse,
    IImportBookingResponse
} from "libraries/service/resources/booking/interfaces/import.interface";
import { IGetBookingsCommonResponse } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { IHostCodesAndAliases } from "libraries/service/resources/host-alias/host-alias.resource";

@Component({
    selector: 'import-booking',
    template: `
        <div class="app-wrapper app-sasha">
            <sasha-breadcrumb></sasha-breadcrumb>

            <card-form #cardForm
                       (onSubmit)="onImport()"
                       [options]="cardFormOption">
                <div class="card-header-content">
                    <h1>{{ labels.title }}</h1>
                </div>

                <div class="card-body-content card-padding-inside">
                    <div class="radio-btn-div">
                        <mat-radio-group [(ngModel)]="importMode" (change)="changeImportMode()" [disabled]="isLoading">
                            <mat-radio-button class="radio-btn"
                                              [value]="simpleImportModeValue">{{labels.simpleImport}}</mat-radio-button>
                            <mat-radio-button class="radio-btn"
                                              [value]="multipleImportModeValue">{{labels.multipleImport}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div class="importField simple" *ngIf="importMode === simpleImportModeValue">
                        <div class="formRow">
                            <combobox-field [fieldConfig]="fieldsConfig.hostName.config"
                                            [items]="fieldsConfig.hostName.items"
                                            class="left_element"></combobox-field>

                            <text [fieldConfig]="fieldsConfig.bookingCode.config"
                                  (onBlur)="updateFormEntity([formGroup, fieldsConfig.bookingCode.config])"
                                  class="right_element"></text>
                        </div>
                    </div>

                    <div class="importField multiple" *ngIf="importMode === multipleImportModeValue">
                        <div class="formRow">
                            <simple-textarea-field [fieldConfig]="fieldsConfig.text.config"
                                                   (onBlur)="updateFormEntity([formGroup, fieldsConfig.text.config])"
                                                   [class]="fullWidthClassValue">
                            </simple-textarea-field>
                        </div>
                        <div class="read-file">
                            <input type="file"
                                   (change)="onFileChange($event.target.files)"
                                   accept=".csv"
                                   [disabled]="isLoading"/>
                        </div>

                    </div>
                    <div>
                        <loader *ngIf="isLoading" [message]="wording.import"></loader>
                        <notification *ngIf="notification.success.isNotification"
                                      [type]="notification.success.notificationType" [showCloseButton]="false"
                                      class="notification">
                            {{notification.success.message}}
                        </notification>
                        <notification *ngIf="notification.error.isNotification"
                                      [type]="notification.error.notificationType" [showCloseButton]="false"
                                      class="notification">
                            <div *ngFor="let text of notification.error.message">
                                {{text}}
                            </div>
                        </notification>
                    </div>
                    <div class="result" *ngIf="isSuccess">
                        <bookings-list
                                [bookings]="bookingResponse">
                        </bookings-list>

                    </div>
                </div>
            </card-form>
        </div>
    `,
    styleUrls: ['./import-booking.component.scss'],
    providers: [ImportBookingFieldsetService]
})
export class ImportBookingComponent implements OnInit {

    @ViewChild('cardForm')
    public cardForm: CardFormComponent;

    public readonly labels: ILabels = {
        title: Yii.t('wui-sasha-js', "Imports de nouveau dossier"),
        resultTitle: Yii.t('wui-sasha-js', "Dossier correctement importé"),
        importBtn: Yii.t('wui-sasha-js', "Importer"),
        simpleImport: Yii.t('wui-sasha-js', "Import simple"),
        multipleImport: Yii.t('wui-sasha-js', "Import multiple"),
        readFileBtn: Yii.t('wui-sasha-js', "Lire le fichier"),
    };

    public readonly simpleImportModeValue: EImportMode = EImportMode.simple;
    public readonly multipleImportModeValue: EImportMode = EImportMode.multiple;

    public importMode: EImportMode = EImportMode.simple;

    public fieldsConfig: IFieldConfig;
    public hostOptions: string[];
    public formGroup: FormGroup;

    public simpleImport: ISimpleBookingImport = {hostName: null, bookingCode: null};

    public multipleImport: { value: string } = {value: null};

    public isLoading: boolean = false;
    public bookingResponse: IGetBookingsCommonResponse[] = [];

    public isSuccess: boolean = false;

    public file: string = null;

    public notification: INotificationImport;

    public readonly fullWidthClassValue: ETextAreaClass = ETextAreaClass.fullWidth;

    public wording: ILabels = {
        import: null
    };

    public cardFormOption: IOptionsCardForm = {
        formGroup: null,
        labels: {
            submit: this.labels.importBtn,
            error: null,
        }
    };

    public isImport: boolean = false;

    private hostCodesAndAliases: IHostCodesAndAliases = null;

    constructor(
        private readonly sashaBreadcrumbService: SashaBreadcrumbService,
        public fb: FormBuilder,
        public importBookingFieldsetService: ImportBookingFieldsetService,
        private readonly bookingResourceService: BookingResourceService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly enumsResourceService: EnumsResourceService,
        private readonly helperService: HelperService,
        private readonly errorTracingService: ErrorTracingService,
    ) {
    }

    public ngOnInit(): void {
        this.sashaBreadcrumbService.setProcessingImport();
        this.clearNotification();
        this.route.queryParams.subscribe((params: IImportQueryParam) => {
            this.init(params);
        });
        this.initForm();

    }

    public updateFormEntity(data: [FormGroup, IFieldSpecs]): void {
        const form: FormGroup = data[0];
        const fieldSpec: IFieldSpecs = data[1];

        const formControlName: string = fieldSpec.formControlName;
        switch (this.importMode) {
            case EImportMode.simple:
                this.simpleImport[formControlName] = form.value[formControlName];
                break;
            case EImportMode.multiple:
                this.multipleImport.value = form.value[formControlName];
                break;
            default:
                break;
        }
        this.simpleImport[formControlName] = form.value[formControlName];
    }

    public onImport(): void {
        markAllTouched(this.formGroup);
        if (this.formGroup.valid) {
            this.clearNotification();
            this.setUrl();
        }
    }

    public onFileLoad(fileLoadedEvent: { target: { result: string } }): void {
        const result: { text: string[] } = this.importBookingFieldsetService.readFile(fileLoadedEvent.target.result);
        this.multipleImport.value = result.text.join("\n");
        this.initForm();
    }

    public onFileChange(input: FileList): void {
        this.clearNotification();
        const file: FileList = input;
        if (file && file.length) {
            const filesToRead: File = file[0];
            const fileReader: FileReader = new FileReader();
            fileReader.onload = this.onFileLoad.bind(this);
            fileReader.readAsText(filesToRead, "UTF-8");
        }
    }

    public changeImportMode(): void {
        this.isImport = false;
        this.initForm();
    }

    private init(params: IImportQueryParam): void {
        if (params.mode) {
            this.importMode = params.mode;
        }
        if (params.host && params.code) {
            if (this.importMode === this.simpleImportModeValue) {
                this.simpleImport = {
                    hostName: params.host.toString(),
                    bookingCode: params.code.toString()
                };
            }
        }
    }

    private initForm(): void {
        switch (this.importMode) {
            case EImportMode.simple:
                this.formGroup = this.fb.group({
                    hostName: new FormControl(this.simpleImport.hostName),
                    bookingCode: new FormControl(this.simpleImport.bookingCode)
                });
                this.fieldsConfig = this.importBookingFieldsetService.initFieldConfig(this.formGroup, EImportMode.simple);
                this.isImport = Boolean(this.simpleImport.bookingCode || this.simpleImport.hostName);
                break;
            case EImportMode.multiple:
                this.formGroup = this.fb.group({
                    text: new FormControl(this.multipleImport.value)
                });
                this.fieldsConfig = this.importBookingFieldsetService.initFieldConfig(this.formGroup, EImportMode.multiple);
                if (this.multipleImport.value === null) {
                    this.isImport = false;
                }
                break;
            default:
                break;
        }
        this.cardFormOption.formGroup = this.formGroup;
        this.initEnums();
    }

    private initEnums(): void {
        this.enumsResourceService.listSystems()
            .subscribe((hostCodesAndAliases: IHostCodesAndAliases) => {
                    this.hostCodesAndAliases = hostCodesAndAliases;
                    if (this.importMode === EImportMode.simple) {
                        this.fieldsConfig.hostName.items = this.helperService.getMultiselectOptions(this.hostCodesAndAliases.aliases, this.hostCodesAndAliases.codes, true);
                    }
                },
                (error: Error) => {
                    this.notification.error.isNotification = true;
                    this.notification.error.message.push(
                        [Yii.t('wui-sasha-js', "Impossible de récupérer la liste des hôtes disponibles"), error].join(' '));
                    this.hostOptions = [];
                }
            );
    }

    private getBookingReference(): IBookingHostCode[] {
        let returnBookingReference: IBookingHostCode[] = [];
        if (this.importMode === this.simpleImportModeValue) {
            returnBookingReference.push({
                code: this.formGroup.value.bookingCode,
                host: this.formGroup.value.hostName
            });
        }
        if (this.importMode === this.multipleImportModeValue) {
            const splitValue: string[] = this.multipleImport.value.split('\n');
            returnBookingReference = this.importBookingFieldsetService.valueSplitter(splitValue, this.hostCodesAndAliases);
        }
        return returnBookingReference;
    }

    private clearNotification(): void {
        this.notification = {
            success: {
                isNotification: false,
                message: null,
                notificationType: NotificationType.Success,
            },
            error: {
                isNotification: false,
                message: [],
                notificationType: NotificationType.Error,
            }
        };
        this.bookingResponse = [];
        this.isSuccess = false;
    }

    private succesResult(value: IGetBookingsCommonResponse[]): void {
        if (value.length) {
            this.notification.success.isNotification = true;
            this.isSuccess = true;
        }
        const successCode: string[] = [];
        value.forEach((succesReponse: IGetBookingsCommonResponse) => {
            this.bookingResponse.push(succesReponse);
            successCode.push(succesReponse.code);
        });
        this.notification.success.message = [successCode.join(' - '), 'Import effectué avec succès'].join(' ');
    }

    private errorResult(value: IImportBookingErrorReponse[]): void {
        if (value.length) {
            this.notification.error.isNotification = true;
        }
        value.forEach((errorResponse: IImportBookingErrorReponse) => {
            const errorMessage: string = [errorResponse.data.host, '/', errorResponse.data.code, '=>', errorResponse.message].join(' ');
            this.notification.error.message.push(errorMessage);
        });
    }

    private setUrl(): void {
        const bookings: IBookingHostCode[] = this.getBookingReference();
        let urlCodeList: string = null;
        let urlHostList: string = null;
        if (this.importMode === this.simpleImportModeValue) {
            urlCodeList = bookings[0].code;
            urlHostList = bookings[0].host;
        }
        this.router.navigate(
            ['sasha/import-booking'],
            {
                queryParams: {
                    host: urlHostList,
                    code: urlCodeList,
                    mode: this.importMode
                }
            }
        ).catch((reason: boolean) => {
            this.errorTracingService.captureException(reason);
        });
        this.import(bookings);
    }

    private import(booking: IBookingHostCode[]): void {
        this.isLoading = true;
        switch (this.importMode) {
            case EImportMode.simple:
                this.wording.import = Yii.t('wui-shared-js', 'Import  du dossier');
                break;
            case EImportMode.multiple:
                this.wording.import = Yii.t('wui-shared-js', 'Import  des dossiers');
                break;
            default:
                break;
        }
        this.bookingResourceService.importBooking(booking).pipe(
            finalize(() => this.isLoading = false)
        ).subscribe(
            (value: IImportBookingResponse) => {
                this.succesResult(value.successes);
                this.errorResult(value.errors);
            },
            (error: string) => {
                this.notification.error.isNotification = true;
                this.notification.error.message.push(error);
            }
        );
    }
}
